export default class BannerScroll {
    static init() {
        const trigger = document.querySelector(".scroll-next-section .btn-magnet");

        if (!trigger) {
            return;
        }

        trigger.addEventListener("click", (e) => {
            e.preventDefault();
            const nextSection = document.querySelector("#banner").nextElementSibling;
            if (nextSection) {
                nextSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        });
        
    }
}